export default __webpack_public_path__ + "static/media/sine440.817a4f0c.mp3";